export const protocolsXRAY = ["Здесь будут протоколы рентгена"];
